import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { UpdatesHOC } from './hocs/UpdatesHOC/UpdatesHOC';

export class UpdatesView {
    el: Element;
    root: Root;
    store: Store;

    constructor (
        store: Store
    ) {
        this.store = store;
        if (this.el) this.remove();
        this.el = document.createElement('div');
        this.el.className = 'updates-panel-placeholder';
        const portal = document.getElementById('navigation-aside-portal');
        if (portal) portal.append(this.el);
        this.root = createRoot(this.el!);
        this.render();
    }

    render () {
        this.root.render(
            <Provider store={this.store}>
                <UpdatesHOC />
            </Provider>
        );
    }

    remove () {
        if (!this.el) return;

        this.root.unmount();
        this.el.remove();
        this.el = null;
    }
}
